import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import Header from './components/Header';
import Tabs from './components/Tabs';
import { Wrapper, DetailWrapper, ResizerWrapper, Resizer, Transparency } from './styled';
import ReduxModal from 'Common/Components/ReduxModal';
import { MODAL_UPGRADE_LICENSE_VULN_DETAIL } from 'store/modals/modals';
import UpgradeLicense from 'Common/Components/UpgradeLicense';
import FFTags from 'Images/ff_tags.png';
import { useResizeX } from 'Hooks/useResize';
import useWindowDimensions from 'Hooks/useWindowSize';
import useShortcutScope from 'Hooks/useShortcutScope';
import useFormShortcuts from 'Hooks/useFormShortcuts';
import ImagePreviewModal from './components/ImagePreviewModal';
import { redirectToManage } from 'store/Manage/actions';
import TabSelector from './components/Tabs/components/TabSelector';
import DeleteConfirmationModal from 'Screens/Credentials/components/ActionBar/components/DeleteConfirmationModal';
import { selectDeleteConfirmation } from 'store/Credentials/selectors';

const VulnerabilityDetail = () => {
  const [showTransparency, setShowTransparency] = useState(false);
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const resizerRef = useRef(null);
  const { width } = useWindowDimensions();
  const minWidth = width < 3000 ? width * 0.55 : width * 0.35;
  const maxWidth = width < 3000 ? width * 0.75 : width * 0.55;
  const wrapperWidth = useResizeX(wrapperRef, resizerRef, minWidth, minWidth, maxWidth);
  const showDeleteCredentialModal = useSelector(selectDeleteConfirmation);
  const dispatch = useDispatch();
  const shortcutScope = useShortcutScope('vuln-detail');

  const handleClose = () => dispatch(redirectToManage());

  useFormShortcuts({ onCancel: handleClose, scope: shortcutScope, cancelLabel: 'Close' });

  const onScroll = () => {
    const scrollTop = get(ref, 'current.scrollTop', 0);
    if (scrollTop === 0) setShowTransparency(false);
    else setShowTransparency(true);
  };

  return (
    <>
      { showDeleteCredentialModal && <DeleteConfirmationModal isVulnDetail /> }
      <ReduxModal id={ MODAL_UPGRADE_LICENSE_VULN_DETAIL }>
        <UpgradeLicense id={ MODAL_UPGRADE_LICENSE_VULN_DETAIL } image={ FFTags } descriptionIntlId={ 'upgradeLicense.sidebar.tags.description' } />
      </ReduxModal>
      <ImagePreviewModal />
      <Wrapper ref={ wrapperRef } wrapperWidth={ wrapperWidth }>
        <ResizerWrapper ref={ resizerRef } children={ <Resizer /> } />
        <DetailWrapper>
          <Header onClose={ handleClose } />
          <TabSelector scope={ shortcutScope } />
          { showTransparency && <Transparency /> }
          <Tabs tabRef={ ref } onScroll={ onScroll } showTransparency={ showTransparency } />
        </DetailWrapper>
      </Wrapper>
    </>
  );
};

export default VulnerabilityDetail;
